<edit-ip-adjustment
  *ngIf="
    (subproject.type == 'Adjustment' ||
      subproject.type == 'Repo' ||
      subproject.type == 'SoldRented') &&
    subproject != null &&
    projectHasIPBoards === true &&
    !this.gettingNewComponent
  "
  [project]="project"
  [model]="subproject"
  [loadSubProject]="loadSubProject"
  (save)="saveSubproject($event)"
  (deleted)="deleted.emit()"
>
</edit-ip-adjustment>

<edit-adjustment
  *ngIf="
    (subproject.type == 'Adjustment' ||
      subproject.type == 'Repo' ||
      subproject.type == 'SoldRented') &&
    subproject != null &&
    projectHasIPBoards === false &&
    !this.gettingNewComponent
  "
  [project]="project"
  [model]="subproject"
  [loadSubProject]="loadSubProject"
  (save)="saveSubproject($event)"
  (deleted)="deleted.emit()"
>
</edit-adjustment>

<edit-project
  *ngIf="
    subproject.type == 'BaseProject' &&
    subproject != null &&
    projectHasIPBoards === false &&
    !this.gettingNewComponent
  "
  [project]="project"
  [model]="subproject"
  [productAdded]="productAdded"
  [boardPartAdded]="boardPartAdded"
  [standardStickerPartAdded]="standardStickerPartAdded"
  [standardStickerPartDeleted]="standardStickerPartDeleted"
  [projectContactIdAssigned]="projectContactIdAssigned"
  (save)="saveSubproject($event)"
>
</edit-project>

<edit-ip-board-project
  *ngIf="
    subproject.type == 'BaseProject' &&
    subproject != null &&
    projectHasIPBoards === true &&
    !this.gettingNewComponent
  "
  [project]="project"
  [model]="subproject"
  [projectContactIdAssigned]="projectContactIdAssigned"
  (save)="saveSubproject($event)"
>
</edit-ip-board-project>

<mat-spinner
  *ngIf="gettingNewComponent"
  color="primary"
  diameter="48"
></mat-spinner>
